module.exports = __webpack_public_path__ + "img/woods_1.9b9a5d36.png";